module.exports = __webpack_public_path__ + "img/6_54.fb0e9e4e.png";